<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <h5 class="mb-0">FORMULAIRE DE RECENSEMENT DES MARCHANDS DE DANTOKPA</h5>
      </div>
      <div class="d-flex align-items-center">
        <button type="button" @click="goBack()" 
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-arrow-left position-relative ms-5 fs-12"></i>
          Retour
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
       <div class="form-header">
          <h2 class="mb-0 text-white">FICHE DE RECENSEMENT DES MARCHANDS DE DANTOKPA</h2>
        </div>
      <Form ref="recensementForm" @submit="soumettre" :validation-schema="recensementSchema">
        
        <!-- Section Agent Recenseur -->
        <div class="section-title">
          <i class="fas fa-user-tie me-2"></i>Informations de l'Agent Recenseur
        </div>
        
        <div class="row mb-3">
          <div class="col-md-8">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Nom et Prénoms de l'agent recenseur <span class="text-danger">*</span>
              </label>
              <Field name="nomPrenomAgent" readonly v-model="nomPrenomAgent" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Nom et prénoms de l'agent recenseur" />
              <ErrorMessage name="nomPrenomAgent" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Téléphone <span class="text-danger">*</span>
              </label>
              <Field name="telephoneAgent" readonly v-model="telephoneAgent" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Téléphone de l'agent" />
              <ErrorMessage name="telephoneAgent" class="text-danger" />
            </div>
          </div>
        </div>
        
        <!-- Section Marchand -->
        <div class="section-title">
          <i class="fas fa-store me-2"></i>Informations du Marchand
        </div>
        
        <div class="row mb-3">
          <div class="col-md-3">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Nom du marchand <span class="text-danger">*</span>
              </label>
              <Field name="nomMarchand" v-model="nomMarchand" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Nom du marchand" />
              <ErrorMessage name="nomMarchand" class="text-danger" />
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Prénom(s) du marchand <span class="text-danger">*</span>
              </label>
              <Field name="prenomMarchand" v-model="prenomMarchand" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Prénom(s) du marchand" />
              <ErrorMessage name="nomPrenomMarchand" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Téléphone
              </label>
              <Field name="telephoneMarchand" v-model="telephoneMarchand" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Téléphone du marchand" />
              <ErrorMessage name="telephoneMarchand" class="text-danger" />
            </div>
          </div>
        </div>
        
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Numéro Personnel d'Identification (NPI)
              </label>
              <Field name="npi" v-model="npi" class="form-control shadow-none fs-md-15 text-black"
                placeholder="+ copie physique requise" />
              <ErrorMessage name="npi" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Secteur d'activité <span class="text-danger">*</span>
              </label>
              <Field name="secteurActivite" v-model="secteurActivite" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Secteur d'activité" />
              <ErrorMessage name="secteurActivite" class="text-danger" />
            </div>
          </div>
        </div>
        
        <!-- Produits/Services dynamiques -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Produits/Services proposés</label>
          <div v-for="(produit, index) in produits" :key="index" class="numbered-input mb-2" :data-number="`${index + 1}.`">
            <div class="d-flex">
              <Field :name="`produit${index + 1}`" v-model="produit.value" class="form-control shadow-none fs-md-15 text-black"
                :placeholder="`Produit/Service ${index + 1}`" />
              <button v-if="produits.length > 1" type="button" @click="removeProduit(index)" 
                class="btn btn-outline-danger ms-2">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
          <button type="button" @click="addProduit" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-plus me-1"></i>Ajouter un produit/service
          </button>
        </div>
        
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Ancienneté dans l'activité (années)
              </label>
              <Field name="anciennete" v-model="anciennete" type="number" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Nombre d'années" min="0" />
              <ErrorMessage name="anciennete" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                N° de l'étalage ou boutique
              </label>
              <Field name="numeroEtalage" v-model="numeroEtalage" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Numéro d'étalage" />
              <ErrorMessage name="numeroEtalage" class="text-danger" />
            </div>
          </div>
        </div>
        
        <!-- SOGEMA Liquidation -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Êtes-vous inscrit sur la liste SOGEMA-Liquidation ?</label>
          <div class="form-check form-check-inline">
            <Field name="sogemaLiquidation" value="oui" type="radio" class="form-check-input" id="sogemaOui" />
            <label class="form-check-label" for="sogemaOui">Oui</label>
          </div>
          <div class="form-check form-check-inline">
            <Field name="sogemaLiquidation" value="non" type="radio" class="form-check-input" id="sogemaNon" />
            <label class="form-check-label" for="sogemaNon">Non</label>
          </div>
          <ErrorMessage name="sogemaLiquidation" class="text-danger d-block" />
        </div>
        
        <!-- Type d'installation -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Type d'installation</label>
          <div class="row">
            <div class="col-md-3">
              <div class="form-check">
                <Field name="typeInstallation" value="boutique" type="checkbox" class="form-check-input" id="boutiqueConstruite" />
                <label class="form-check-label" for="boutiqueConstruite">Boutique construite</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check">
                <Field name="typeInstallation" value="kiosque" type="checkbox" class="form-check-input" id="kiosque" />
                <label class="form-check-label" for="kiosque">Kiosque</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check">
                <Field name="typeInstallation" value="table" type="checkbox" class="form-check-input" id="tableEtalage" />
                <label class="form-check-label" for="tableEtalage">Table/étalage</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check">
                <Field name="typeInstallation" value="ambulant" type="checkbox" class="form-check-input" id="ambulant" />
                <label class="form-check-label" for="ambulant">Ambulant</label>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Type de marchand -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Type de marchand</label>
          <div class="form-check form-check-inline">
            <Field name="typeMarchand" value="locataire" type="radio" class="form-check-input" id="locataire" />
            <label class="form-check-label" for="locataire">Locataire</label>
          </div>
          <div class="form-check form-check-inline">
            <Field name="typeMarchand" value="exploitant" type="radio" class="form-check-input" id="exploitant" />
            <label class="form-check-label" for="exploitant">Exploitant</label>
          </div>
          <ErrorMessage name="typeMarchand" class="text-danger d-block" />
        </div>
        
        <div class="mb-3">
          <div class="form-group">
            <label class="d-block text-black fw-semibold">
              Nombre de personnes travaillant avec vous
            </label>
            <Field name="nombrePersonnes" v-model="nombrePersonnes" type="number" class="form-control shadow-none fs-md-15 text-black"
              placeholder="Nombre de personnes" min="0" />
            <ErrorMessage name="nombrePersonnes" class="text-danger" />
          </div>
        </div>
        
        <!-- Lien avec associations/coopératives -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Lien avec associations/coopératives</label>
          <div class="row">
            <div class="col-md-6">
              <div class="form-check">
                <Field name="lienAssociation" value="oui" type="radio" class="form-check-input" id="assocOui" 
                  @change="toggleAssociationInput" />
                <label class="form-check-label" for="assocOui">Oui (préciser)</label>
              </div>
              <Field name="precisionAssociation" v-model="precisionAssociation" class="form-control shadow-none fs-md-15 text-black mt-2"
                placeholder="Précisez l'association/coopérative" :disabled="!showAssociationInput" />
            </div>
            <div class="col-md-6">
              <div class="form-check">
                <Field name="lienAssociation" value="non" type="radio" class="form-check-input" id="assocNon" 
                  @change="toggleAssociationInput" />
                <label class="form-check-label" for="assocNon">Non</label>
              </div>
            </div>
          </div>
          <ErrorMessage name="lienAssociation" class="text-danger d-block" />
        </div>
        
        <!-- Besoins -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Besoins</label>
          <div class="row">
            <div class="col-md-4">
              <div class="form-check">
                <Field name="besoins" value="boutique" type="checkbox" class="form-check-input" id="besoinBoutique" />
                <label class="form-check-label" for="besoinBoutique">Boutique</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <Field name="besoins" value="stand" type="checkbox" class="form-check-input" id="besoinStand" />
                <label class="form-check-label" for="besoinStand">Stand</label>
              </div>
            </div>
            <div class="col-md-4">
              <Field name="autresBesoin" v-model="autresBesoin" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Autres besoins" />
            </div>
          </div>
        </div>
        
        <!-- Mutualisation -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Souhaitez-vous la mutualisation ?</label>
          <div class="row">
            <div class="col-md-6">
              <div class="form-check">
                <Field name="mutualisation" value="oui" type="radio" class="form-check-input" id="mutualOui" 
                  @change="toggleMutualisationInput" />
                <label class="form-check-label" for="mutualOui">Oui (préciser)</label>
              </div>
              <Field name="precisionMutualisation" v-model="precisionMutualisation" class="form-control shadow-none fs-md-15 text-black mt-2"
                placeholder="Précisez le type de mutualisation" :disabled="!showMutualisationInput" />
            </div>
            <div class="col-md-6">
              <div class="form-check">
                <Field name="mutualisation" value="non" type="radio" class="form-check-input" id="mutualNon" 
                  @change="toggleMutualisationInput" />
                <label class="form-check-label" for="mutualNon">Non</label>
              </div>
            </div>
          </div>
          <ErrorMessage name="mutualisation" class="text-danger d-block" />
        </div>
        
        <!-- Observations -->
        <div class="mb-3">
          <div class="form-group">
            <label class="d-block text-black fw-semibold">
              Observations de l'agent recenseur
            </label>
            <Field name="observations" v-model="observations" as="textarea" class="form-control shadow-none fs-md-15 text-black"
              rows="4" placeholder="Notez ici vos observations..." />
            <ErrorMessage name="observations" class="text-danger" />
          </div>
        </div>
        
        <!-- Date et signature -->
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Date du recensement <span class="text-danger">*</span>
              </label>
              <Field name="dateRecensement" v-model="dateRecensement" type="date" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateRecensement" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="d-block text-black fw-semibold">
                Signature de l'agent recenseur
              </label>
              <Field name="signatureAgent" v-model="signatureAgent" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Nom complet pour signature" />
              <ErrorMessage name="signatureAgent" class="text-danger" />
            </div>
          </div>
        </div>
        
        <!-- Upload de fichiers -->
        <div class="mb-3">
          <label class="d-block text-black fw-semibold mb-3">Documents justificatifs</label>
          <div class="product-upload mb-10">
            <div class="dz-message needsclick">
              <DropZone name="fichiers[]" :maxFilesize="50" :maxFiles="30"
                :uploadOnDrop="true" @addedFile="onFileAdd" @removedFile="onFileRemove" :options="dropzoneOptions"
                @vdropzone-success="onSuccess" @vdropzone-error="onError">
                <div class="default-image-container" v-if="!hasFiles">
                  <img :src="defaultImage" alt="Default" class="default-image" />
                  <p>Glissez et déposez ici vos documents</p>
                </div>
              </DropZone>
            </div>
          </div>
        </div>
        
        <!-- Boutons d'action -->
        <div class="text-center">
          <!-- Bouton Aperçu PDF -->
          <PDFGeneratorSimple 
            :form-data="getFormData()" 
            :form-ref="recensementForm" 
          />
          
          <button type="submit" class="btn btn-primary btn-lg me-3" :disabled="isSubmitting">
            <span v-if="isSubmitting" class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            <i v-if="!isSubmitting" class="fas fa-save me-2"></i>
            {{ isSubmitting ? 'Enregistrement...' : 'Enregistrer le recensement' }}
          </button>
          <button type="button" @click="resetForm" class="btn btn-secondary btn-lg">
            <i class="fas fa-undo me-2"></i>Réinitialiser
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import DropZone from "dropzone-vue";
import { useRouter, useRoute } from "vue-router";
import PDFGeneratorSimple from "./PDFGeneratorSimple.vue";

export default defineComponent({
  name: "FicheRecensement",
  components: {
    Form,
    Field,
    ErrorMessage,
    DropZone,
    PDFGeneratorSimple
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isSubmitting = ref(false);
    
    // Schema de validation
    const recensementSchema = Yup.object().shape({
      nomPrenomAgent: Yup.string().required("Le nom et prénoms de l'agent recenseur sont obligatoires"),
      telephoneAgent: Yup.string().required("Le téléphone de l'agent recenseur est obligatoire"),
      nomMarchand: Yup.string().required("Le nom du marchand est obligatoire"),
      prenomMarchand: Yup.string().required("Le prénoms du marchand est obligatoires"),
      telephoneMarchand: Yup.string().notRequired(),
      npi: Yup.string()
        .nullable()
        .test("len", "Le NPI doit faire exactement 10 chiffres", (value) => {
          return !value || /^\d{10}$/.test(value);
        }),
      secteurActivite: Yup.string().required("Le secteur d'activité est obligatoire"),
      anciennete: Yup.number().nullable().min(0, "L'ancienneté doit être positive"),
      numeroEtalage: Yup.string().nullable(),
      nombrePersonnes: Yup.number().nullable().min(0, "Le nombre de personnes doit être positif"),
      precisionAssociation: Yup.string().nullable(),
      autresBesoin: Yup.string().nullable(),
      precisionMutualisation: Yup.string().nullable(),
      observations: Yup.string().nullable(),
      dateRecensement: Yup.date().required("La date du recensement est obligatoire"),
      signatureAgent: Yup.string().nullable(),
    });

    // Refs pour les champs
    const recensementForm = ref();
    const nomMarchand = ref("");
    const prenomMarchand = ref("");
    const nomPrenomAgent = ref("");
    const telephoneAgent = ref("");
    const nomPrenomMarchand = ref("");
    const telephoneMarchand = ref("");
    const npi = ref("");
    const secteurActivite = ref("");
    const anciennete = ref("");
    const numeroEtalage = ref("");
    const nombrePersonnes = ref("");
    const precisionAssociation = ref("");
    const autresBesoin = ref("");
    const precisionMutualisation = ref("");
    const observations = ref("");
    const dateRecensement = ref("");
    const signatureAgent = ref("");



    // Produits dynamiques
    const produits = ref([{ value: "" }, { value: "" }, { value: "" }]);

    // Logique conditionnelle
    const showAssociationInput = ref(false);
    const showMutualisationInput = ref(false);

    // Upload de fichiers
    const defaultImage = ('/public/welcome2.png');
    const hasFiles = ref(false);
    const toutFichier = ref<Array<File>>([]);

    const dropzoneOptions = {
      url: '/public/welcome2.png',
      thumbnailWidth: 150,
      maxFilesize: 50,
      maxFiles: 10,
      headers: { "My-Awesome-Header": "header value" },
      acceptedFiles: ".jpg,.png,.pdf",
    };

    // Fonctions pour produits dynamiques
    const addProduit = () => {
      produits.value.push({ value: "" });
    };

    const removeProduit = (index: number) => {
      if (produits.value.length > 1) {
        produits.value.splice(index, 1);
      }
    };

    // Fonctions pour logique conditionnelle
    const toggleAssociationInput = (event: Event) => {
      const target = event.target as HTMLInputElement;
      showAssociationInput.value = target.value === 'oui';
      if (!showAssociationInput.value) {
        precisionAssociation.value = '';
      }
    };

    const toggleMutualisationInput = (event: Event) => {
      const target = event.target as HTMLInputElement;
      showMutualisationInput.value = target.value === 'oui';
      if (!showMutualisationInput.value) {
        precisionMutualisation.value = '';
      }
    };

    // Fonctions d'upload
    const onFileAdd = (file: any) => {
      toutFichier.value.push(file["file"]);
      hasFiles.value = true;
    };

    const onFileRemove = (file: File) => {
      const index = toutFichier.value.findIndex(fil => 
        ((fil.name === file["file"].name) && (fil.size === file["file"].size) && (fil.type === file["file"].type))
      );
      if (index !== -1) {
        toutFichier.value.splice(index, 1);
      }
      hasFiles.value = toutFichier.value.length > 0;
    };

    const onSuccess = (file: any) => {
      //console.log('Upload réussi:', file);
    };

    const onError = (file: any, message: any) => {
      //console.error('Erreur de téléchargement:', message);
    };

    // Fonctions utilitaires
    const resetForm = () => {
      nomPrenomAgent.value = "";
      telephoneAgent.value = "";
      nomPrenomMarchand.value = "";
      telephoneMarchand.value = "";
      npi.value = "";
      secteurActivite.value = "";
      anciennete.value = "";
      numeroEtalage.value = "";
      nombrePersonnes.value = "";
      precisionAssociation.value = "";
      autresBesoin.value = "";
      precisionMutualisation.value = "";
      observations.value = "";
      dateRecensement.value = new Date().toISOString().split('T')[0];
      signatureAgent.value = "";
      produits.value = [{ value: "" }, { value: "" }, { value: "" }];
      toutFichier.value = [];
      hasFiles.value = false;
      showAssociationInput.value = false;
      showMutualisationInput.value = false;
    };

    const goBack = () => {
      router.go(-1);
    };

    // Fonction pour récupérer les données du formulaire pour le PDF
    const getFormData = () => {
      const formData = {
        nomPrenomAgent: nomPrenomAgent.value,
        telephoneAgent: telephoneAgent.value,
        nomMarchand: nomMarchand.value,
        prenomMarchand: prenomMarchand.value,
        telephoneMarchand: telephoneMarchand.value,
        npi: npi.value,
        secteurActivite: secteurActivite.value,
        anciennete: anciennete.value,
        numeroEtalage: numeroEtalage.value,
        nombrePersonnes: nombrePersonnes.value,
        precisionAssociation: precisionAssociation.value,
        autresBesoin: autresBesoin.value,
        precisionMutualisation: precisionMutualisation.value,
        observations: observations.value,
        dateRecensement: dateRecensement.value,
        signatureAgent: signatureAgent.value,
        produits: produits.value.filter(p => p.value.trim() !== ''),
        showAssociationInput: showAssociationInput.value,
        showMutualisationInput: showMutualisationInput.value
      };
      return formData;
    };

    // Soumission du formulaire
    const soumettre = async (values: any, { resetForm }: any) => {
      isSubmitting.value = true;
      
      // Ajouter les informations de l'utilisateur connecté
      values["userCreation"] = JwtService.getUser();
      values['autreFichier[]'] = [];
      
      // Ajouter les fichiers uploadés
      if (toutFichier.value.length > 0) {
        values['autreFichier[]'] = toutFichier.value;
      }

      // Préparer les produits/services
      values.produitsServices = produits.value.filter(p => p.value.trim() !== '').map(p => p.value);

      try {
        // Si il y a des fichiers, utiliser FormData
        if (toutFichier.value.length > 0) {
          values['autreFichier[]'] = toutFichier.value;
        } 
        //headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },

        const response = await axios.post("recensement/usager", values, {
          headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
        });
        
        success("Le recensement des marchands de Dantokpa a été enregistré avec succès");
        resetForm();
        router.push('/liste-recensements');
      } catch (err) {
        if (err instanceof AxiosError) {
          error(err.response?.data?.message || "Une erreur est survenue lors de l'enregistrement");
        } else {
          error("Une erreur est survenue lors de l'enregistrement");
        }
      } finally {
        isSubmitting.value = false;
      }
    };

    onMounted(() => {
      // Pré-remplir la date du jour
      dateRecensement.value = new Date().toISOString().split('T')[0];
      
      // Pré-remplir les informations de l'agent recenseur depuis l'authentification
      const user = JwtService.getUser();
      if (user && typeof user === 'object') {
        nomPrenomAgent.value = (user as any).nom || '';
        telephoneAgent.value = (user as any).telephone || '';
        signatureAgent.value = (user as any).nom || '';
      }
      nomPrenomAgent.value = JwtService.getUserName() || '';
      telephoneAgent.value = JwtService.getUserPhone() || '';
      signatureAgent.value = JwtService.getUserName() || '';
      
      // Vérifier s'il y a des données d'usager à pré-remplir
      const route = useRoute();
      if (route.query.usagerData) {
        try {
          const usagerData = JSON.parse(route.query.usagerData as string);
          
          // Pré-remplir les champs avec les données de l'usager
          if (usagerData.nom) nomMarchand.value = usagerData.nom;
          if (usagerData.prenom) prenomMarchand.value = usagerData.prenom;
          if (usagerData.tel) telephoneMarchand.value = usagerData.tel;
          if (usagerData.npi) npi.value = usagerData.npi;
          if (usagerData.adresse) {
            // Note: Le champ adresse n'existe pas dans le formulaire actuel
            // Vous pouvez l'ajouter si nécessaire
          }
          if (usagerData.email) {
            // Note: Le champ email n'existe pas dans le formulaire actuel
            // Vous pouvez l'ajouter si nécessaire
          }
          if (usagerData.lieu_naissance) {
            // Note: Le champ lieu de naissance n'existe pas dans le formulaire actuel
            // Vous pouvez l'ajouter si nécessaire
          }
          if (usagerData.nationalite) {
            // Note: Le champ nationalité n'existe pas dans le formulaire actuel
            // Vous pouvez l'ajouter si nécessaire
          }
          
          // Pré-remplir les informations d'emplacement si disponibles
          if (usagerData.contrats && usagerData.contrats.length > 0) {
            const contrat = usagerData.contrats[0];
            if (contrat.codeemp && contrat.codeemp.ncodeEmp) {
              numeroEtalage.value = contrat.codeemp.ncodeEmp;
            }
          }
          
        } catch (error) {
          console.error('Erreur lors du parsing des données usager:', error);
        }
      }
    });
    
    return {
      // Form
      recensementForm,
      recensementSchema,
      isSubmitting,
      
      // Champs principaux
      nomPrenomAgent,
      telephoneAgent,
      nomMarchand,
      prenomMarchand,
      telephoneMarchand,
      npi,
      secteurActivite,
      anciennete,
      numeroEtalage,
      nombrePersonnes,
      precisionAssociation,
      autresBesoin,
      precisionMutualisation,
      observations,
      dateRecensement,
      signatureAgent,
      
      // Produits dynamiques
      produits,
      addProduit,
      removeProduit,
      
      // Logique conditionnelle
      showAssociationInput,
      showMutualisationInput,
      toggleAssociationInput,
      toggleMutualisationInput,
      
      // Upload fichiers
      defaultImage,
      hasFiles,
      dropzoneOptions,
      onFileAdd,
      onFileRemove,
      onSuccess,
      onError,
      
      // Fonctions
      soumettre,
      resetForm,
      goBack,
      getFormData,
    };
  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
/* Styles pour reproduire le design du formulaire HTML */

.form-header {
    background: linear-gradient(135deg, #2c3e50, #3498db);
    color: white !important;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 30px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}
.section-title {
  background: linear-gradient(135deg, #34495e, #2980b9);
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 25px 0 15px 0;
  font-weight: 600;
  font-size: 1.1em;
}

.form-control, .form-select {
  border: 2px solid #e3e6f0;
  border-radius: 8px;
  padding: 12px 15px;
  transition: all 0.3s ease;
}

.form-control:focus, .form-select:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 0.2rem rgba(52, 152, 219, 0.25);
}

.form-check-input:checked {
  background-color: #3498db;
  border-color: #3498db;
}

.btn-primary {
  background: linear-gradient(135deg, #3498db, #2980b9);
  border: none;
  padding: 12px 30px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2980b9, #1f4e79);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
}

.numbered-input {
  position: relative;
}

.numbered-input::before {
  content: attr(data-number);
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-weight: 600;
  z-index: 1;
}

.numbered-input .form-control {
  padding-left: 35px;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';
</style>
